import { Component, OnInit, OnDestroy } from '@angular/core';

import * as jp from "jsonpath/jsonpath";
//import { PDFProgressData, PDFDocumentProxy } from 'pdfjs-dist';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { BaseControlComponent } from '../../base-control/base-control.component';
import { ReportSelectorService } from '../../../services/report-selector.service';
import { GenerateReportModel } from "../../../../reports/model/reports.model";

import { genId } from '../../../../core/services/genId';
import { ContextInteractionService } from '../../../services/context-interaction.service';


@Component({
    selector: 'app-report-pdf-view',
    templateUrl: './report-pdf-view.component.html',
    styleUrls: ['./report-pdf-view.component.scss'],
    standalone: false
})
export class ReportPdfViewComponent extends BaseControlComponent implements OnInit, OnDestroy {

    static componentName = 'ReportPdfViewComponent';

    public _isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    currentPage: number = 1;
    pdf: any;
    reportSrc: string = undefined;
    subscription: Subscription;
    totalPages: number;

    get isLoading$(): Observable<boolean> {
        return this._isLoading$.asObservable();
    }

    constructor(public reportService: ReportSelectorService, public readonly contextService: ContextInteractionService) {
        super(contextService);
    }

    ngOnInit() {
        this.initializeConfig();
        if (!this.componentContext) return;
        const html = this.getContextData(this.componentData.config.reportTarget);
        const orderNumber = this.getContextData(this.componentData.config.chiefsOrderNumber);
        const certifiedMailId = this.getContextData(this.componentData.config.certifiedMailId);

        if (html) {
            const model = {
                useBanner: this.componentData.config.useBanner,
               /* useChiefsOrderHeader: this.componentData.config.useChiefsOrderHeader,*/
                usePageNumberHeader: this.componentData.config.usePageNumberHeader,
                formatAsLetter: true,
                html: html,
                styleMergeFields: false
                //chiefOrderNumber: orderNumber,
                //certifiedMailId: certifiedMailId
            } as GenerateReportModel;

            this.subscription = this.reportService.generate(model).subscribe(pdfStream => {
                const blobUrl = window.URL.createObjectURL(pdfStream);
                this.reportSrc = blobUrl;
                this.pdf = pdfStream;
            });
        }
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    download(): void {
        const blob = new Blob([this.pdf], { type: "application/pdf" });
        const fileName = `${genId()}.pdf`;
		var url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.download = fileName;
		link.click();
		setTimeout(() => {
			URL.revokeObjectURL(url);
		});
    }

    initializeConfig(): void {
        if (this.componentData.config === undefined || this.componentData.config === null) {
            this.componentData.config = {};
        }
        if (this.componentData.config.reportTarget === undefined || this.componentData.config.reportTarget === null) {
            this.componentData.config.reportTarget = '$.data.reportTemplate';
        }
        if (this.componentData.config.chiefsOrderNumber === undefined || this.componentData.config.chiefsOrderNumber === null) {
            this.componentData.config.chiefsOrderNumber = '$.reporting.chiefOrderNumber';
        }
        if (this.componentData.config.certifiedMailId === undefined || this.componentData.config.certifiedMailId === null) {
            this.componentData.config.certifiedMailId = '$.reporting.certifiedMailId';
        }
        if (this.componentData.config.useBanner === undefined || this.componentData.config.useBanner === null) {
            this.componentData.config.useBanner = true;
        }
        if (this.componentData.config.useChiefsOrderHeader === undefined || this.componentData.config.useChiefsOrderHeader === null) {
            this.componentData.config.useChiefsOrderHeader = true;
        }
        if (this.componentData.config.usePageNumberHeader === undefined || this.componentData.config.usePageNumberHeader === null) {
            this.componentData.config.usePageNumberHeader = false;
        }
    }

    nextPage(): void {
        if(this.currentPage >= this.totalPages) return;
        this.currentPage++;
    }

//onLoadComplete(pdf: PDFDocumentProxy): void {
	onLoadComplete(pdf: any): void {
        this.totalPages = pdf.numPages;
    }

/*    onProgress(progressData: PDFProgressData): void {*/
	onProgress(progressData: any): void {
        this._isLoading$.next(false);
    }

    previousPage(): void {
        if (this.currentPage <= 1) return;
        this.currentPage--;
    }
}
